import { useFlag } from '@/lib/api';

export const HYBRID_SORTING_FLAG = 'hybrid_sorting_ui';

/**
 * Gates the Asset Binder menu item and its route. The binder is a screen of its own
 * rather than a replacement for the Asset 360 folder views, so nothing here changes an
 * existing screen and every subfolder renders through the same columns UI.
 */
export function useHybridSorting() {
    const { data, isLoading } = useFlag(HYBRID_SORTING_FLAG);

    return { isEnabled: !!data, isLoading };
}
